import { createContext, useState } from "react";

const TranslateContext = createContext({
  enteredText: "",
  language: "es-MX",
  transText: "",
  setTransText: () => {},
  setLanguage: () => {},
  setEnteredText: () => {},
});

export function TranslationContextProvider(props) {
  const [transText, setTransText] = useState("");
  const [language, setLanguage] = useState("es-ES");
  const [enteredText, setEnteredText] = useState("");

  function setTranslatedText(transText) {
    setTransText(transText);
  }

  function setLanguageHandler(language) {
    setLanguage(language);
  }

  function setEnteredTextHandler(enteredText) {
    setEnteredText(enteredText);
  }

  const context = {
    enteredText,
    language,
    transText,
    setTransText: setTranslatedText,
    setLanguage: setLanguageHandler,
    setEnteredText: setEnteredTextHandler,
  };

  return (
    <TranslateContext.Provider value={context}>
      {props.children}
    </TranslateContext.Provider>
  );
}

export default TranslateContext;
